import ApiDataService from "@/api/apiData.service";
import {PageRequest} from "@/api/utils/page-request";
class OpendataService{
  apiDataService : ApiDataService = new ApiDataService();

  async getGroups(){
    return await this.apiDataService.get("/api/v1/opendata/groups");
  }
  async getGroup(id : number){
    return await this.apiDataService.get(`/api/v1/opendata/groups`,id.toString());
  }
  async getDatasets(){
    return await this.apiDataService.get("/api/v1/opendata/datasets");
  }
  async getDataset(id : number){
    return await this.apiDataService.get(`/api/v1/opendata/datasets`,id.toString());
  }
  async getResources(id : number){
    return await this.apiDataService.get(`/api/v1/opendata/resources`,id.toString());
  }
  async getFaqs() {
    return await this.apiDataService.get("/api/v1/opendata/faqs");
  }
  async getTagSummary() {
    return await this.apiDataService.get("/api/v1/opendata/tag/summary");
  }
  async getFormatSummary() {
    return await this.apiDataService.get("/api/v1/opendata/format/summary");
  }
  async getGroupSummary() {
    return await this.apiDataService.get("/api/v1/opendata/group/summary");
  }
  async updateDatasetView(id: number) {
    return await this.apiDataService.put(`/api/v1/opendata/datasets/view/${id}`, null);
  }
  async getRecentPopularSidebar(type: string, pageRequest: PageRequest) {
    return await this.apiDataService.query(`/api/v1/opendata/datasets/sidebar/${type}`, pageRequest);
  }
}

export default OpendataService;
